var React = require('react');

function NoteIcon1 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"d":"M453.94,0h-367a5.05,5.05,0,0,0-.68.07,5.38,5.38,0,0,0-2,.81c-.08,0-.14.12-.21.17a4.31,4.31,0,0,0-.62.51h0L1.56,83.39h0a5.46,5.46,0,0,0-.65.79h0a4.63,4.63,0,0,0-.5.93h0a5,5,0,0,0-.31,1h0a6.64,6.64,0,0,0-.1,1V556.4a5.53,5.53,0,0,0,5.52,5.53H453.94a5.54,5.54,0,0,0,5.53-5.53h0V5.52A5.52,5.52,0,0,0,454,0ZM81.49,19.17,80.13,80.65,19,81.65ZM448.42,550.86H11V92.79l74.62-1.17a5.52,5.52,0,0,0,5.43-5.41l1.66-75.16h355.7Z"}))));
}

NoteIcon1.defaultProps = {"viewBox":"0 0 459.47 561.93"};

module.exports = NoteIcon1;

NoteIcon1.default = NoteIcon1;
